import React from 'react';
import { haptic } from '../../utils/haptics';
import styles from './agentChat.module.css';

const SIGN = { ILS: '₪', USD: '$', EUR: '€', GBP: '£' };

/**
 * THE SERVICES THE AGENT NAMED, AS CARDS (owner 10-23: "Book service (which adds it)"). Each shows its name, its price
 * as the business page shows it (nothing where the page hides it) and its length; "Book" adds it to the booking in
 * progress (`onBook` → the server's `book_service` step); the quiet "?" makes it the subject of the conversation.
 */
export default function ServiceStrip({ services, currency = 'ILS', onBook, onAsk, busy = false, t }) {
  if (!services?.length) return null;
  const sign = SIGN[currency] ?? '';
  return (
    <div className={styles.strip} role="list" data-testid="agent-service-strip">
      {services.map((s) => {
        const priced = s.priceShown !== false && s.price !== null && s.price !== undefined;
        return (
          <div key={s.id} role="listitem" className={`${styles.card} ${styles.offerCard}`}>
            <div className={styles.offerBody}>
              <div className={styles.cardName}>{s.name}</div>
              <div className={styles.cardPrice}>
                {priced ? <strong>{sign}{s.price}</strong> : null}
                {s.minutes ? <span className={styles.offerMeta}>{t('agent.minutes', { defaultValue: '{{count}} min', count: s.minutes })}</span> : null}
              </div>
              {s.description ? <div className={styles.offerDescription}>{s.description}</div> : null}
            </div>
            <div className={styles.cardActions}>
              {onBook ? <button type="button" className={styles.cardAction} disabled={busy} onClick={() => onBook(s)}>{t('agent.book', { defaultValue: 'Book' })}</button> : null}
              {onAsk ? (
                <button type="button" className={styles.askAbout} aria-label={t('agent.askAboutThis', { defaultValue: 'Ask about this' })} title={t('agent.askAboutThis', { defaultValue: 'Ask about this' })} onClick={() => { haptic('selection'); onAsk(s); }}>
                  <span aria-hidden="true">?</span>
                </button>
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}
